import React, { useState, useContext } from "react";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import IconButton from "@mui/material/IconButton";
import CardActions from "@mui/material/CardActions";
import { USER_FEEDBACK } from "../consts";
import { FeedbackDialog } from "./feedback-dialog";
import { logUserFeedback } from "../feedback-service";
import { UrlParamsContext } from "../../../app/context/url-params-context";

interface FeedbackButtonsProps {
  showFeedback: boolean;
  messageId: number | undefined;
}

export const FeedbackButtons = ({
  showFeedback,
  messageId,
}: FeedbackButtonsProps) => {
  const { functionKey } = useContext(UrlParamsContext);
  const [userFeedback, setUserFeedback] = useState<string | null>(null);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  const handleThumbUp = (): void => {
    if (userFeedback === USER_FEEDBACK.POSITIVE) {
      return;
    }
    setUserFeedback(USER_FEEDBACK.POSITIVE);
    logUserFeedback(messageId, USER_FEEDBACK.POSITIVE, functionKey);
  };
  const handleThumbDown = (): void => {
    setUserFeedback(USER_FEEDBACK.NEGATIVE);
    setDialogOpen(true);
  };
  const handleDialogClose = (): void => {
    setDialogOpen(false);
    logUserFeedback(messageId, USER_FEEDBACK.NEGATIVE, functionKey);
  };
  const handleDialogSubmit = (comment: string): void => {
    if (comment.trim()) {
      logUserFeedback(
        messageId,
        `${USER_FEEDBACK.NEGATIVE};${comment.trim()}`,
        functionKey
      );
    } else {
      logUserFeedback(messageId, USER_FEEDBACK.NEGATIVE, functionKey);
    }
    setDialogOpen(false);
  };
  const handleDialogCancel = (): void => {
    setDialogOpen(false);
    setUserFeedback(null);
  };
  if (!showFeedback) return null;
  return (
    <CardActions>
      <IconButton
        onClick={handleThumbUp}
        color={
          userFeedback === USER_FEEDBACK.POSITIVE ? "primary" : "secondary"
        }
      >
        <ThumbUpIcon />
      </IconButton>
      <IconButton
        onClick={handleThumbDown}
        color={
          userFeedback === USER_FEEDBACK.NEGATIVE ? "primary" : "secondary"
        }
        disableFocusRipple
      >
        <ThumbDownIcon />
      </IconButton>
      <FeedbackDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        onSubmit={handleDialogSubmit}
        onCancel={handleDialogCancel}
      />
    </CardActions>
  );
};
